// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FL-z","twoColumnImage":"GL-z"};